import { debounce } from 'lodash';
import { useMemo } from 'react';
import { InternalFieldName, UseFormRegisterReturn } from 'react-hook-form';

export const useDebouncedFieldRegistry = <TFieldName extends InternalFieldName = InternalFieldName>(
  registerFunc: () => UseFormRegisterReturn<TFieldName>,
  delay = 1000,
) => {
  const field = useMemo(() => {
    const registration = registerFunc();
    return {
      ...registration,
      onChange: debounce(registration.onChange, delay),
    };
  }, [delay, registerFunc]);

  return field;
};
